/**
 * 1.67 (193) — the waiter's phone: the app's tabs, the bill, the add sheet, „მზადაა", „მე", the push text.
 */
export const waiter = {
  'waiter.off.title': 'ანგარიში გათიშულია',
  'waiter.off.body': 'მფლობელმა თქვენი მიმტანის ანგარიში გათიშა. მიმართეთ მას.',
  'waiter.off.signOut': 'გასვლა',
  // the push notification (the Worker writes it in the device's language)
  'waiter.push.title': '{table} — მზადაა',
  // 1.69 — a guest at a table asks through the QR menu (the Worker writes it in the device's language)
  'waiter.push.call.title': '{table} — გიძახებენ',
  'waiter.push.call.body': 'სტუმარი მიმტანს იძახებს',
  'waiter.push.order.title': '{table} — ახალი შეკვეთა',
  'waiter.push.order.body': 'სტუმარმა მენიუდან შეუკვეთა — ნახე და დაადასტურე',
  'waiter.push.check.title': '{table} — ანგარიში',
  'waiter.push.check.body': 'სტუმარი ანგარიშს ითხოვს',

  // the tabs
  'waiter.tab.tables': 'მაგიდები',
  'waiter.tab.ready': 'მზადაა',
  'waiter.tab.me': 'მე',
  'waiter.offline': 'ინტერნეტი არ არის — სანამ არ დაბრუნდება, შეკვეთები ვერ გაიგზავნება',
  'waiter.banner.sub': 'წაიღე სამზარეულოდან',

  // the tables
  'waiter.mine': 'ჩემი · {n}',
  'waiter.all': 'ყველა · {n}',
  'waiter.noTables': 'მაგიდები ჯერ არ არის — მფლობელი პარამეტრებში დაამატებს',
  'waiter.readyCount': '{n} მზადაა',

  // the bill
  'waiter.bill.title': 'მაგიდა {name}',
  'waiter.group.toTake': 'წასაღებია',
  'waiter.group.kitchen': 'სამზარეულოშია',
  'waiter.group.fresh': 'ახალი — ჯერ არ გაგზავნილა',
  'waiter.group.served': 'მაგიდაზეა',
  'waiter.served': 'მივიტანე',
  'waiter.servedOk': 'მიტანილია',
  'waiter.servedAll': 'ყველა მივიტანე',
  'waiter.send': 'გაგზავნა · {n}',
  'waiter.sentOk': 'გაიგზავნა',
  'waiter.noScreen': '{station}: ეკრანი ჩართული არ არის — შეკვეთა ჩაიწერა და ეკრანის ჩართვისას გამოჩნდება; საჭიროებისას დაბეჭდეთ სალაროდან',
  'waiter.check': 'ანგარიში',
  'waiter.checkAsked': 'ანგარიში მოთხოვნილია',
  'waiter.checkAskedOk': 'სალაროს ეცნობა — ანგარიშს მოლარე დაბეჭდავს',
  'waiter.add': 'დამატება',
  'waiter.more': 'მეტი',
  'waiter.take': 'მაგიდის გადმობარება',
  'waiter.taken': 'მაგიდა შენია',
  'waiter.ofWaiter': 'მიმტანი: {name}',
  'waiter.noWaiter': 'მიმტანი არ ჰყავს',
  'waiter.line.cancel': 'ულუფის გაუქმება',
  'waiter.line.unserve': 'მიტანის გაუქმება',
  'waiter.line.note': 'შენიშვნა',
  'waiter.line.remove': 'წაშლა',
  'waiter.empty': 'ანგარიში ცარიელია — დაამატე პროდუქცია',

  // the add sheet
  'waiter.search': 'ძებნა ან კოდი',
  'waiter.categories': 'კატეგორიები',
  'waiter.allProducts': 'ყველა',
  'waiter.noProducts': 'ვერაფერი მოიძებნა',

  // ready
  'waiter.ready.title': 'მზადაა',
  'waiter.ready.empty': 'მზა კერძი ჯერ არ არის',
  'waiter.ready.paid': 'გადახდილია',
  'waiter.ready.dishes': '{n} კერძი',

  // me
  'waiter.me.branch': 'ფილიალი',
  'waiter.me.push': 'შეტყობინებები',
  'waiter.me.pushOn': 'ჩართულია',
  'waiter.me.pushOff': 'გამორთულია',
  'waiter.me.pushEnable': 'შეტყობინებების ჩართვა',
  'waiter.me.pushHint': 'ჩაკეტილ ტელეფონზეც მოგივა, როცა კერძი მზად იქნება',
  'waiter.me.pushDenied': 'ტელეფონმა შეტყობინებები დაბლოკა — ჩართე ბრაუზერის პარამეტრებში',
  'waiter.me.pushUnsupported': 'ეს ბრაუზერი შეტყობინებებს ვერ იღებს',
  'waiter.me.pushFailed': 'შეტყობინებები ვერ ჩაირთო — სცადე ცოტა ხანში',
  'waiter.me.iphone': 'iPhone-ზე: „გაზიარება“ → „მთავარ ეკრანზე დამატება“, მერე აპი იქიდან გახსენი',
  'waiter.me.signOut': 'გასვლა',

  // 1.68 (196) — the bill with its service, the check's state, the waiter's shift
  'waiter.total': 'ჯამი',
  'waiter.check.printing': 'იბეჭდება სალაროში…',
  'waiter.check.printed': 'დაიბეჭდა {time}',
  'waiter.check.again': 'ხელახლა',
  'waiter.check.failed': 'ვერ დაიბეჭდა — სალაროში დაბეჭდავენ',
  'waiter.me.shift': 'ეს ცვლა',
  'waiter.me.shiftFrom': '{from}-დან',
  'waiter.me.checks': 'ანგარიშები',
  'waiter.me.guests': 'სტუმრები',
  'waiter.me.sales': 'გაყიდვები',
  'waiter.me.service': 'მომსახურება',
  'waiter.me.returnsNote': 'დაბრუნება წინა ცვლის თანხას ამცირებს',
  'waiter.me.noShift': 'ცვლა ჯერ არ გახსნილა',
  'waiter.me.statsFailed': 'ციფრები ვერ ჩაიტვირთა — სცადე ცოტა ხანში',
} as const
